import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import {
  Frame,
  TopBar,
  Navigation,
  Toast,
  Button,
  InlineStack,
  BlockStack,
  Text
} from '@shopify/polaris';
import {
  HomeIcon,
  SettingsIcon,
  PersonIcon,
  ClockIcon,
  TeamIcon,
  ExitIcon,
  ChatIcon,
  ClipboardChecklistIcon
} from '@shopify/polaris-icons';
import { useAuth } from '../contexts/AuthContext';
import zemtrixMark from '../assets/zemtrix-mark.png';

const ADMIN_NAV_ITEMS = [
  { label: 'Dashboard', icon: HomeIcon, url: '/dashboard' },
  { label: 'Users', icon: PersonIcon, url: '/users' },
  { label: 'Time Entries', icon: ClockIcon, url: '/time-entries' },
  { label: 'Telegram Messages', icon: ChatIcon, url: '/working-time/telegram' },
  { label: 'Monthly Reviews', icon: ClipboardChecklistIcon, url: '/monthly-reviews' },
  { label: 'User Management', icon: TeamIcon, url: '/user-management' },
  { label: 'Settings', icon: SettingsIcon, url: '/settings' }
];

const MANAGER_NAV_ITEMS = [{ label: 'Review Times', icon: ClipboardChecklistIcon, url: '/working-time/review' }];

const Layout = ({ children }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { user, logout } = useAuth();
  const navItems = user?.role === 'admin' ? ADMIN_NAV_ITEMS : MANAGER_NAV_ITEMS;
  const [mobileNavigationActive, setMobileNavigationActive] = useState(false);
  const [toastActive, setToastActive] = useState(false);

  const toggleMobileNavigationActive = () =>
    setMobileNavigationActive(!mobileNavigationActive);

  const handleLogout = () => {
    logout();
    setToastActive(true);
  };

  const topBarMarkup = (
    <TopBar
      showNavigationToggle
      onNavigationToggle={toggleMobileNavigationActive}
      secondaryMenu={
        <InlineStack gap="400" blockAlign="center" align="end">
          <BlockStack gap="0" inlineAlign="end">
            <Text as="span" variant="bodyXs" tone="subdued">
              Logged in as
            </Text>
            <Text as="span" variant="bodySm" fontWeight="semibold">
              {user?.username || 'User'}
            </Text>
          </BlockStack>
          <Button onClick={handleLogout} size="slim" variant="tertiary" tone="critical" icon={ExitIcon}>
            Logout
          </Button>
        </InlineStack>
      }
    />
  );

  const navigationMarkup = (
    <Navigation location={location.pathname}>
      <div className="zx-logo">
        <img src={zemtrixMark} alt="" className="zx-logo__mark-img" />
        <span className="zx-logo__text">Zemtrix</span>
      </div>
      <Navigation.Section
        items={navItems.map((item) => ({
          label: item.label,
          icon: item.icon,
          url: item.url,
          matches: location.pathname === item.url,
          onAction: () => navigate(item.url)
        }))}
      />
    </Navigation>
  );

  const toastMarkup = toastActive ? (
    <Toast content="Successfully logged out" onDismiss={() => setToastActive(false)} duration={3000} />
  ) : null;

  return (
    <Frame
      topBar={topBarMarkup}
      navigation={navigationMarkup}
      showMobileNavigation={mobileNavigationActive}
      onNavigationDismiss={toggleMobileNavigationActive}
    >
      {children}
      {toastMarkup}
    </Frame>
  );
};

export default Layout;
